export { default } from './LocationAutocomplete.vue'
